//components
import { Spin } from "antd";

//style
import style from "./Loading.module.css";

export const Loading: React.FC = () => {
  return (
    <div className={style.loading}>
      <Spin size="large" />
    </div>
  );
};
